export default {
  moduleName: 'works',
  apis: [
      {
          funName: 'info',
          methodType: 'get',
          url: 'info'
      },
      {
          funName: 'findList',
          methodType: 'get',
          url: 'list'
      },
      {
        funName: 'queryList',
        methodType: 'post',
        url: 'list',
        contentType: true
      },
      {
          funName: 'findPage',
          methodType: 'get',
          url: 'page'
      },
      {
          funName: 'insert',
          methodType: 'post',
          url: 'insert'
      },
      {
          funName: 'update',
          methodType: 'post',
          url: 'save'
      },
      {
          funName: 'query',
          methodType: 'post',
          url: 'page',
          contentType:true
      },
      {
        funName: 'deleteWork',
        methodType: 'get',
        url: 'delete'
      },
      {
        funName: 'mongoList',
        methodType: 'get',
        url: 'mongo/list'
      },
      {
        funName: 'getWorkByJid',
        methodType: 'get',
        url: 'judge'
      },
      {
        funName: 'saveWork',
        methodType: 'post',
        url: 'saveMongo',
        contentType: true
      },
      {
        funName: 'getJudgeCounter',
        methodType: 'get',
        url: 'counter'
      },
      {
        funName: 'findMongoPage',
        methodType: 'post',
        url: 'mongo/page',
        contentType: true
      },
      {
        funName: 'findMongoPersonPage',
        methodType: 'post',
        url: 'mongo/person/page',
        contentType: true
      },
      {
        funName: 'findAwardList',
        methodType: 'post',
        url: 'award/list',
        contentType: true
      },
      {
        funName: 'findAwardPhotoList',
        methodType: 'get',
        url: 'photo/list',
        contentType: true
      },
      {
        funName: 'changePhotoStatus',
        methodType: 'post',
        url: 'photo/status',
        contentType: true
      }
      
      
      
  ]
}